/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RaSendMhResponse
 */
export interface RaSendMhResponse {
    /**
     * 
     * @type {string}
     * @memberof RaSendMhResponse
     */
    gpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RaSendMhResponse
     */
    xmlRequest?: string;
}

/**
 * Check if a given object implements the RaSendMhResponse interface.
 */
export function instanceOfRaSendMhResponse(value: object): value is RaSendMhResponse {
    return true;
}

export function RaSendMhResponseFromJSON(json: any): RaSendMhResponse {
    return RaSendMhResponseFromJSONTyped(json, false);
}

export function RaSendMhResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RaSendMhResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gpCode': json['gpCode'] == null ? undefined : json['gpCode'],
        'xmlRequest': json['xmlRequest'] == null ? undefined : json['xmlRequest'],
    };
}

export function RaSendMhResponseToJSON(json: any): RaSendMhResponse {
    return RaSendMhResponseToJSONTyped(json, false);
}

export function RaSendMhResponseToJSONTyped(value?: RaSendMhResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gpCode': value['gpCode'],
        'xmlRequest': value['xmlRequest'],
    };
}

